import Vue from "vue";
import Router from "vue-router";
import Layout from "@/layout";
Vue.use(Router);

/* Layout */
// import Advertisement from "./modules/Advertisement/index";
import HeadOfficeManagement from "./modules/HeadOfficeManagement/index";
/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   如果设置为true,项目将不会显示在顶部栏和侧边栏中(默认为false)
 * alwaysShow: true               如果设置为true,将始终显示根菜单
 *                                如果不设置alwaysShow,当item有多个子路由时,
 *                                它将变成嵌套模式,否则不显示根菜单
 * redirect: noRedirect           如果设置noRedirect,则不会在面包屑中重定向
 * name:'router-name'             如果要是用路由缓存<keep-alive>(必须设置!!)
 * display:true                   如果只有一个要显示的子路由又想是下拉的方式就添加这个属性
 * meta : {
    roles: ['admin','editor']    控制页面角色(可以设置多个角色)
    title: 'title'               名称显示在侧边栏和面包屑中(推荐设置)
    icon: 'svg-name'/'el-icon-x' 图标显示在侧栏中
    breadcrumb: false            如果设置为false,该项将隐藏在breadcrumb中(默认为true)
    activeMenu: '/example/list'  如果设置路径,侧边栏将突出显示您设置的路径
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */

export let constantRoutes = [
  {
    path: "/login",
    component: () => import("@/views/login/index"),
    hidden: true
  },

  {
    path: "/404",
    component: () => import("@/views/404"),
    hidden: true
  },
  {
    path: "/dashboard",
    component: () => import("@/views/dashboard"),
    hidden: true
  },
  {
    path: "/",
    // component: () => import('@/views/dashboard'),
    redirect: "/HeadOfficeManagement/Home/HomeIndexPage",
    hidden: true
  },
  {
    path: "/redirect",
    component: Layout,
    name: "redirect",
    hidden: true,
    children: [
      {
        path: "/redirect/:path(.*)",
        component: () => import("@/views/redirect/index")
      }
    ]
  },
  HeadOfficeManagement,
  // 404 页面必须放在末尾!!
  // { path: '*', redirect: '/404', hidden: true }
];
const createRouter = () =>
  new Router({
    // mode: 'history', // require service support
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRoutes
  });

let router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter(routes) {
  const newRouter = createRouter();
  router.matcher = newRouter.matcher; // reset router
  console.log(constantRoutes);
  console.log(routes);
}

export default router;
